import { allocateEmployees, cancelReportAction, consentUpload, createConsent, createDrive, decrementVacancy, downloadConsent, downloadMeritTemplate, downloadReportAction, downloadVacancyTemplate, employeeEligible, employeeJoining, fetchAllCandidates, fetchAllEmployees, fetchAllocatedEmployee, fetchAllocatedEmployees, fetchAllocation, fetchAllocationStatus, fetchConsentDrive, fetchDashboard, fetchDrive, fetchDriveVacancy, fetchEligibleEmployees, fetchEmpAllocation, fetchEmployeeAllocationLetter, fetchEmployeeProfile, fetchEmployeesMerit, fetchEmployeeTimeline, fetchJoinedEmployees, fetchLaunchStatus, fetchPreviousPostingDetails, fetchReportsHistoryAction, fetchReportsTypesAction, fetchRevokedPostingEmployees, getCurrentDriveConfig, grantPreviousPosting, launchAllocation, launchAllocationDrive, meritUpload, newDriveConfig, revokePosting, submitReportsTypeAction, vacancyUpload } from "../../services/AdminService";
import { formatError, formatSuccess } from "../../services/AuthService";
import { loadingToggleAction } from "./AuthActions";
import { SEND_OTP_FAILED_ACTION } from "./PreferencesActions";

export const FETCH_DASHBOARD_ADMIN = '[admin action] confirmed dashboard';
export const ALLOCATION_ADMIN = '[admin action] confirmed allocation';
export const FETCH_ALLOC_ADMIN = '[admin action] fetch allocation';
export const FETCH_ALLOC_STATUS_ADMIN = '[admin action] fetch allocation-status';
export const FETCH_ALLOC_LAUNCH_STATUS_ADMIN = '[admin action] fetch launch-status';
export const FETCH_ALLOC_EMP = '[emp action] fetch allocation';
export const ALLOCATION_LAUNCHED = '[admin action] launch allocation';
export const FETCH_JOINED = '[admin action] fetch allocated';
export const FETCH_ELIGIBLE = '[admin action] fetch eligible';
export const FETCH_MERIT = '[admin action] fetch merit';
export const FETCH_VACANCY = '[admin action] fetch vacancy';
export const DECREMENT_VACANCY = '[admin action] decrement vacancy';
export const FETCH_EMP = '[navigate action] join allocated';
export const FETCH_ALLOCATED = '[admin action] fetch joined';
export const FETCH_ALLOCATED_EMP = '[admin action] fetch-emp allocated';
export const FETCH_TIMELINE_EMP = '[admin action] fetch-emp timeline';
export const FETCH_LETTER_EMP = '[admin action] fetch-emp letter';
export const CLEAR_TIMELINE_DATA = '[admin action] clear timeline data';
export const UPDATE_JOINING = '[admin action] update joining';
export const MARK_ELIGIBLE = '[admin action] mark eligible';
export const FETCH_DRIVE = '[admin action] fetch drive';
export const FETCH_CONSENT = '[admin action] fetch consent drive';
export const FETCH_REPORTS_TYPES = '[admin action] fetch reports types';
export const FETCH_REPORTS_HISTORY = '[admin action] fetch reports history';
export const FETCH_ALL_EMP = '[admin action] fetch ALL-EMPLOYEES';
export const FETCH_REVOKED_POSTING = '[admin action] fetch revoked-posting';
export const FETCH_PREVIOUS_POSTING = '[admin action] fetch previous-posting';
export const GRANT_PREVIOUS_POSTING = '[admin action] grant previous-posting';
export const UPDATE_ELIGIBILITY = '[admin action] update eligibility';
export const SEND_OTP_FAILED_ACTION_ADMIN = '[admin action] fail otp';
export const SEND_OTP_ACTION_ADMIN = '[admin action] success otp';
export const VACANCY_TEMPLATE_ADMIN = '[admin action] template vacancy';
export const FETCH_CURRENT_DRIVE_CONFIG = '[admin action] fetch current drive config';
export const CREATE_DRIVE_CONFIG = '[admin action] create drive config';
export const SHOW_LOADER = '[loader action]';

export function fetchDashboardAction(drive) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchDashboard(drive).then((response) => {
            dispatch({ type: FETCH_DASHBOARD_ADMIN, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function fetchAllocationAction(drive) {
    return (dispatch) => {
        fetchAllocation(drive).then((response) => {
            dispatch({ type: FETCH_ALLOC_ADMIN, payload: response.data });
        }).catch((error) => {
        })
    }
}
export function fetchAllocationStatusAction(drive) {
    return (dispatch) => {
        // dispatch(loadingToggleAction(true));
        fetchAllocationStatus(drive).then((response) => {
            dispatch({ type: FETCH_ALLOC_STATUS_ADMIN, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            // dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchLaunchStatusAction(drive) {
    return (dispatch) => {
        fetchLaunchStatus(drive).then((response) => {
            dispatch({ type: FETCH_ALLOC_LAUNCH_STATUS_ADMIN, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchEmpAllocationAction() {
    return (dispatch) => {
        fetchEmpAllocation().then((response) => {
            dispatch({ type: FETCH_ALLOC_EMP, payload: response.data });
        }).catch((error) => {
        });
    }
}
export function allocateEmployeesAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        dispatch({ type: SHOW_LOADER, payload: true });
        allocateEmployees().then((response) => {
            dispatch({ type: SHOW_LOADER, payload: false });
            dispatch(fetchAllocationAction());
            dispatch(fetchDrivesAction());
            
            if (response.data && response.data.success) {
                formatSuccess(response.data.message || 'Allocation processed successfully');
            } else {
                formatError(response.data?.message || 'Allocation processing failed');
            }
            
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            dispatch({ type: SHOW_LOADER, payload: false });
            if (error.response?.data) {
                const errorData = error.response.data;
                if (errorData.success === false) {
                    formatError(errorData.message || 'Allocation processing failed');
                } else {
                    formatError(errorData.message || 'An error occurred');
                }
            } else {
                formatError('An error occurred during allocation processing');
            }
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function launchAllocationAction(navigate, otp) {
    return (dispatch) => {
        launchAllocation(otp).then((response) => {
            dispatch({ type: SEND_OTP_FAILED_ACTION, payload: false })
            dispatch(fetchAllocationStatusAction())
            navigate("/dashboard")
            dispatch(fetchDrivesAction());
            // formatSuccess(response.data);
        }).catch((error) => {
            console.log(error)
            // formatError(error.response.data)
        });
    }
}
export function launchAllocationDriveAction(navigate, otp, drive) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        launchAllocationDrive(otp, drive).then((response) => {
            dispatch({ type: SEND_OTP_FAILED_ACTION, payload: false })
            dispatch(fetchAllocationStatusAction())
            navigate("/dashboard")
            dispatch(fetchDrivesAction());
            // formatSuccess(response.data);
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            console.log(error)
            // formatError(error.response.data)
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchAllocatedEmployeeAction(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchAllocatedEmployee(regNo).then((response) => {
            dispatch({ type: FETCH_ALLOCATED_EMP, payload: response.data });
        }).catch((error) => {
            console.log(error)
            formatError(error.response?.data?.message)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchEmployeeTimelineAction(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchEmployeeTimeline(regNo).then((response) => {
            dispatch({ type: FETCH_TIMELINE_EMP, payload: response.data });
        }).catch((error) => {
            console.log(error)
            formatError(error.response?.data?.message)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchEmployeeAllocationLetterAction(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchEmployeeAllocationLetter(regNo).then((response) => {
            dispatch({ type: FETCH_LETTER_EMP, payload: response.data });
        }).catch((error) => {
            console.log(error)
            formatError(error.response?.data?.message)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export const clearTimelineDataAction = () => {
  return {
    type: CLEAR_TIMELINE_DATA
  };
};
export function fetchAllocatedEmployeesAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchAllocatedEmployees().then((response) => {
            dispatch({ type: FETCH_ALLOCATED, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchEligibleEmployeesAction() {
    return (dispatch) => {
        fetchEligibleEmployees().then((response) => {
            dispatch({ type: FETCH_ELIGIBLE, payload: response.data });
        }).catch((error) => {
        });
    }
}
export function fetchAllEmployeesAction() {
    return (dispatch) => {
        fetchEligibleEmployees().then((response) => {
            dispatch({ type: FETCH_ELIGIBLE, payload: response.data });
        }).catch((error) => {
        });
    }
}
export function fetchEmployeesMeritAction(drive) {
    return (dispatch) => {
        fetchEmployeesMerit(drive).then((response) => {
            dispatch({ type: FETCH_MERIT, payload: response.data });
        }).catch((error) => {
        });
    }
}
export function fetchDriveVacancyAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchDriveVacancy().then((response) => {
            dispatch({ type: FETCH_VACANCY, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function fetchConsentAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchConsentDrive().then((response) => {
            dispatch({ type: FETCH_CONSENT, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function fetchReportsTypes() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchReportsTypesAction().then((response) => {
            dispatch({ type: FETCH_REPORTS_TYPES, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function fetchReportsHistory(page = 0, size = 10, status = '') {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchReportsHistoryAction(page, size, status).then((response) => {
            dispatch({ type: FETCH_REPORTS_HISTORY, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function submitReportsType(reportCode) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        submitReportsTypeAction(reportCode).then((response) => {
             formatSuccess(response?.data?.message)
        }).catch((error) => {
             formatError(error?.response?.data?.message)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function cancelReport(reportCode) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        cancelReportAction(reportCode).then((response) => {
            formatSuccess(response?.data?.message);
            // Refresh the report history after cancellation
            dispatch(fetchReportsHistory());
        }).catch((error) => {
            formatError(error?.response?.data?.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function downloadReport(reportCode) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        downloadReportAction(reportCode).then((response) => {
            // Create blob from response data
            const blob = new Blob([response.data], { 
                type: response.headers['content-type'] || 'application/octet-stream' 
            });
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            
            // Extract filename from content-disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `report_${reportCode}.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }
            
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            
            formatSuccess('Report downloaded successfully');
        }).catch((error) => {
            formatError(error?.response?.data?.message || 'Failed to download report');
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function decrementVacancyAction(department, district, post) {
    return (dispatch) => {
        decrementVacancy(department, district, post).then((response) => {
            dispatch(fetchDriveVacancyAction());
        }).catch((error) => {
        });
    }
}
export function fetchJoinedEmployeesAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchJoinedEmployees().then((response) => {
            dispatch({ type: FETCH_JOINED, payload: response.data });
        }).catch((error) => {
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        })
    }
}
export function updateJoinedEmployeeAction(formData) {
    return (dispatch) => {
        employeeJoining(formData).then((response) => {
            formatSuccess(response?.data)
            dispatch({ type: UPDATE_JOINING, payload: true });
        }).catch((error) => {
            formatError(error.response?.data)
            dispatch({ type: UPDATE_JOINING, payload: false });
        });
    }
}
export function updateMarkEmployeeEligibleAction(formData, isBulk) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        employeeEligible(formData, isBulk).then((response) => {
            dispatch(fetchEligibleEmployeesAction())
            dispatch(fetchRevokedPostingEmployeesAction())
            formatSuccess(response?.data)
            dispatch({ type: MARK_ELIGIBLE, payload: true });
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data)
            dispatch({ type: MARK_ELIGIBLE, payload: false });
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function vacancyUploadAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        vacancyUpload(formData).then((response) => {
            dispatch(fetchDriveVacancyAction())
            formatSuccess(response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function consentUploadAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        consentUpload(formData).then((response) => {
            formatSuccess(response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function downloadConsentDriveAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        downloadConsent(formData).then((response) => {
             // Create blob from response data
            const blob = new Blob([response.data], { 
                type: response.headers['content-type'] || 'application/octet-stream' 
            });
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            
            // Extract filename from content-disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Consent_report_${formData}.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }
            
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            formatSuccess(response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function createConsentDriveAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        createConsent(formData).then((response) => {
           dispatch(fetchConsentAction());
            formatSuccess(response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function meritUploadAction(formData, drive) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        meritUpload(formData).then((response) => {
            dispatch(fetchEmployeesMeritAction(drive))
            formatSuccess(response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data?.message)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function fetchDrivesAction() {
    return (dispatch) => {
        fetchDrive().then((response) => {
            dispatch({ type: FETCH_DRIVE, payload: response.data });
        }).catch((error) => {
            console.log(error.response?.data)
        });
    }
}
export function fetchAllCandidatesAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchAllCandidates().then((response) => {
            dispatch({ type: FETCH_ALL_EMP, payload: response.data });
        }).catch((error) => {
            console.log(error.response?.data)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function createDriveAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        const payload = {
            drive: formData.drive,
            verified: formData.isVerified,
        };
        createDrive(payload).then((response) => {
            formatSuccess(response?.data)
            dispatch(fetchDrivesAction());
        }).catch((error) => {
            formatError(error.response?.data)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function fetchRevokedPostingEmployeesAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchRevokedPostingEmployees().then((response) => {
            dispatch({ type: FETCH_REVOKED_POSTING, payload: response.data });
        }).catch((error) => {
            console.log(error.response?.data)
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });

    }
}
export function revokePostingAction(formData, isBulk = false) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        revokePosting(formData, isBulk).then((response) => {
            formatSuccess(response?.data)
            dispatch({ type: FETCH_ALLOCATED_EMP, payload: '' });
            dispatch(fetchRevokedPostingEmployeesAction());
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            formatError(error.response?.data)
            dispatch(loadingToggleAction(false));
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function downloadVacancyTemplateAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        downloadVacancyTemplate().then((response) => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Vacancy_Upload_Template.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }).catch((error) => {
            formatError(error.response.data.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function downloadMeritTemplateAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        downloadMeritTemplate().then((response) => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Merit_Upload_Template.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }).catch((error) => {
            formatError(error.response.data.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function fetchPreviousPostingDetailsAction(regNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        fetchPreviousPostingDetails(regNo).then((response) => {
            dispatch({ type: FETCH_PREVIOUS_POSTING, payload: response.data });
        }).catch((error) => {
            formatError(error.response?.data?.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function grantPreviousPostingAction(formData) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        grantPreviousPosting(formData).then((response) => {
            formatSuccess(response.data);
            dispatch({ type: GRANT_PREVIOUS_POSTING, payload: response.data });
        }).catch((error) => {
            console.log(error)
            formatError(error.response?.data?.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function fetchCurrentDriveConfigAction() {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        getCurrentDriveConfig().then((response) => {
            dispatch({ type: FETCH_CURRENT_DRIVE_CONFIG, payload: response.data });
        }).catch((error) => {
            console.log(error);
            formatError(error.response?.data?.message || 'Failed to fetch current drive configuration');
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}

export function newDriveConfigAction(driveConfigRequest) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        newDriveConfig(driveConfigRequest).then((response) => {
            formatSuccess(response.data || 'Drive configuration created successfully');
            dispatch(fetchDrivesAction());
            dispatch(fetchCurrentDriveConfigAction());
        }).catch((error) => {
            console.log(error);
            formatError(error.response?.data?.message || 'Failed to create drive configuration');
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}